import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { RestrictRemovePatterns, RestrictType } from './input-restrict';


export function applyRestriction(
  control: FormControl,
  type: RestrictType
): void {

  const pattern = RestrictRemovePatterns[type];

  control.valueChanges.subscribe(value => {
    if (value == null) return;

    const sanitized = String(value).replace(pattern, '');

    if (value !== sanitized) {
      control.setValue(sanitized, { emitEvent: false });
    }
  });
}

export function applyDynamicRestriction(
  control: FormControl,
  getPattern: () => RegExp
): Subscription {

  return control.valueChanges.subscribe(value => {
    if (value == null) return;

    const pattern = getPattern();
    const sanitized = value.replace(pattern, '');

    if (value !== sanitized) {
      control.setValue(sanitized, { emitEvent: false });
    }
  });
}
